module.exports = __webpack_public_path__ + "static/img/SmartPlatform7.013e4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SmartPlatform7.png
// module id = pJNp
// module chunks = 13